<template>
  <div>
    <topPage :title="title" :bgImg="bgImg" />
    <!-- <v-container id="next" my-5>
      <v-row align="center" justify="space-between" style="min-height:95vh">
        <v-col cols="12" md="5">
          <h1 v-html="title2"></h1>
          <p>
            Fort d’une expertise de près de 30 ans dans le domaine de
            l’immobilier, Nous avons su accompagner nos copropriétaires dans
            tous leurs projets ainsi que dans la gestion quotidienne de leur
            (lieu de vie / copropriété). Pour autant nous continuons à innover
            pour apporter la meilleure expérience possible à nos
            copropriétaires.
          </p>
          <v-row align="center">
            <v-col cols="auto">
              <em class="mt-5">CITATION</em>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn color="primary">En savoir +</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col
              cols="3"
              v-for="n in 4"
              :key="n"
              :class="n % 2 ? 'mt-5' : 'mb-5'"
              :data-aos="n % 2 ? 'fade-up' : 'fade-down'"
            >
              <v-img :src="require(`@/assets/illu${n}.png`)"></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container> -->
    <v-container my-5 id="next">
      <v-row align="center">
        <v-col cols="12" class="text-center">
          <h3 v-html="title3"></h3>
          <!-- <p>
            Pour satisfaire au mieux la demande de nos clients, nous «traitons
            <br />l’immeuble» dans sa globalité pour en comprendre tous ses
            aspects.
          </p> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="3"
          v-for="(item, index) in list"
          :key="index"
          data-aos="zoom-in"
          :data-aos-delay="300 * index"
        >
          <v-card
            class="d-flex flex-column justify-space-between"
            height="100%"
          >
            <v-card-text class="text-center">
              <v-img
                contain
                height="100"
                :src="require(`@/assets/${item.img}`)"
              ></v-img>
              <v-card-title class="justify-center">
                <span :style="`color:${item.color}`">{{ item.title }}</span>
              </v-card-title>
              {{ item.text }}
            </v-card-text>
            <!-- <v-card-actions class="justify-center pb-5">
              <v-btn
                :color="item.color"
                dark
                tile
                depressed
                class="px-4"
                :to="{ name: item.to }"
                >découvrir</v-btn
              >
            </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- <FullSizeImg
      img="parc1.png"
      title="suivez notre actualité"
      text="Blabla sur si vous faites pas ça vous aller rater plein de trucs"
      btn="découvrir"
      to="https://medium.com/@pagesti"
    ></FullSizeImg> -->
  </div>
</template>

<script>
import topPage from "../components/topPage";
import ImgAndTextLeft from "../components/imageAndTextLeft";
import FullSizeImg from "../components/fullSizeImg";
export default {
  name: "Home",
  components: { topPage, ImgAndTextLeft, FullSizeImg },
  data: () => ({
    bgImg: "paris_illu.png",
    title: "VOTRE AGENCE IMMOBILIERE<br> DE PROXIMITE",
    title2: "PAGESTI: une approche humaine",
    title3: "Nos domaines d'activités",
    list: [
      {
        img: "gestion.svg",
        color: "#F7DE73",
        title: "GESTION",
        text: "On sait vous écouter et être poche de vous",
        to: "gestion",
      },
      {
        img: "location.svg",
        color: "#72F5C4",
        title: "LOCATION",
        text: "Une solution clé en main",
        to: "location",
      },
      {
        img: "transaction.svg",
        color: "#F76767",
        title: "TRANSACTION",
        text: "Au cœur des immeubles la vente est plus facile",
        to: "transaction",
      },
      {
        img: "syndic.svg",
        color: "#7574E9",
        title: "SYNDIC",
        text: "À vos côtés pour gérer votre copropriété",
        to: "syndic",
      },
    ],
  }),
  mounted() {
    this.$refs.map.style.backgroundImage = `url(${require(`@/assets/map.png`)})`;
  },
};
</script>

<style lang="scss" scoped>
#map {
  background-size: cover;
}
a.contact {
  color: #707070 !important;
  & i {
    color: #707070 !important;
  }
  &:hover {
    color: #3b3b3b !important;
    i {
      color: #3b3b3b !important;
    }
  }
}
</style>
